import { contractorApi } from '@/lib/api'

import { ContractorOnboardingState } from '../types'

export function getContractorOnboardingState() {
  return contractorApi.get<ContractorOnboardingState>(
    '/v1/contractor-onboarding',
  )
}
